export const subscriptionsKeys = {
  all: ["subscriptions"] as const,
  current: () => [...subscriptionsKeys.all, "current"] as const,
};
